import msalClient from '@auth/msal/client';
import createApolloClient from './createApolloClient';

const apolloClient = createApolloClient(
    msalClient,
    import.meta.env.VITE_API_URI,
);

export default apolloClient;
